import { render, staticRenderFns } from "./metadata-interactive.vue?vue&type=template&id=27adb163&scoped=true&"
import script from "./metadata-interactive.vue?vue&type=script&lang=js&"
export * from "./metadata-interactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adb163",
  null
  
)

export default component.exports